// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/paragraph/ParagraphStaticComponent.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/paragraph/ParagraphStaticComponent.tsx");
  import.meta.hot.lastModified = "1732036225887.0015";
}
// REMIX HMR END

import { AuditContact, AuditTool, ContactForm, ContactInfo, DrupalCountdown } from "~/components/static";
import AuditHome from "~/components/static/AuditTool/AuditHome";
const components = {
  contact: ContactForm,
  contact_info: ContactInfo,
  audit_contact: AuditContact,
  audit_tool: AuditTool,
  audit_home: AuditHome,
  drupal_7_countdown: DrupalCountdown
};
export default function StaticComponent(props) {
  const Component = components[props.component];
  if (Component) {
    return <Component />;
  }
  return <p className="border-y border-neutral-500 p-4 break-words">
      {JSON.stringify(props)}
    </p>;
}
_c = StaticComponent;
var _c;
$RefreshReg$(_c, "StaticComponent");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;